import { Field, Form, Formik } from 'formik';
import { Modal } from 'react-bootstrap';
import { TEXTAREA_ROW_LENGTH } from '../../../constants/constants';
import { kishuMarkOptions } from '../../../constants/options.constant';
import validCharacters from '../../../constants/valid-characters';
import { IAddKishu, IUpdateKishu } from '../../../models/forms/IAddUpdateKishu';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import { IOption } from '../../../models/ICommon';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormikFormSelect from '../../../shared-components/FormikFormHandlers/FormikFormSelect';
import FormikFormTextArea from '../../../shared-components/FormikFormHandlers/FormikFormTextArea';
import { KishuValidateSchema } from '../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import DefaultModalDraggable from '../../../shared-components/modal/default-modal-draggable';
import ModalFooter from '../../../shared-components/modal/modal-footer';

interface IProps extends IAddEditFormProps<IAddKishu | IUpdateKishu> {
  KishuTypeOptions: IOption[];
}

const AddEditKishuMarkForm = ({
  id,
  initialValues,
  isLoading,
  KishuTypeOptions,
  submitHandler,
  onModalClosed,
}: IProps) => {
  return (
    <>
      <DefaultModalDraggable
        onModalClosed={onModalClosed}
        headerText={id < 0 ? 'add_Kishu' : 'update_kishu'}
        isLoading={isLoading}
        className="addKishu"
        saveUpdateBtnText={id < 0 ? 'save' : 'update'}
        cancelBtnText={'cancel'}
      >
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={KishuValidateSchema}
          validateOnBlur={false}
          onSubmit={async (values) => {
            submitHandler(values);
          }}
        >
          {() => {
            return (
              <Form className="Kishu-form">
                {isLoading && <FormLoader loading={isLoading} />}
                <Modal.Body>
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          required={true}
                          label="kishu"
                        />
                        <Field
                          data-testid="testKishuName"
                          className="form-control"
                          name="Kishu"
                          type="text"
                          placeholder=""
                          as={FormikFormInput}
                          validcharacter={validCharacters}
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          required={true}
                          label="kishu_mark"
                        />
                        <Field
                          name="KishuMark"
                          as={FormikFormSelect}
                          options={kishuMarkOptions}
                          setDefaultValue={true}
                          getData={true}
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group formSet">
                        <Label
                          className="label-style col-form-label"
                          required={false}
                          label="Comment"
                        />
                        <Field
                          rows={TEXTAREA_ROW_LENGTH}
                          id="Comment"
                          className="form-control"
                          name="Remarks"
                          placeholder=""
                          type="text"
                          as={FormikFormTextArea}
                        />
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <ModalFooter
                  id={id}
                  onModalClosed={onModalClosed}
                  isLoading={isLoading}
                  saveNextBtn={'save'}
                  backCancelBtn="cancel"
                />
              </Form>
            );
          }}
        </Formik>
      </DefaultModalDraggable>
    </>
  );
};

export default AddEditKishuMarkForm;
